module.exports = __webpack_public_path__ + "img/img79.a54b0ef0.png";